<template>
<div class="chapter">
<div class="inner_page">
<h1 class="preface-title2"><a href="#/toc#toc-preface002">FAMILY TREES</a></h1>
<p class="center"><span>Genealogies<a id="p18"></a> of the Agiad and Eurypontid Dynasties</span></p>
<p class="center1"><span><img alt="image" height="650" src="images/Art_P18.jpg" width="424"/></span></p>
<p class="center"><span>Eurypontid<a id="p19"></a> Kings of Sparta</span></p>
<p class="center1"><span><img alt="image" height="682" src="images/Art_P19.jpg" width="406"/></span></p>
<p class="center"><span>The<a id="p20"></a> Achaimenids</span></p>
<p class="center2"><span><img alt="image" height="331" src="images/Art_P20.jpg" width="369"/></span></p>
<p class="center"><span>The <a id="p21"></a>Alkmaionidai</span></p>
<p class="center2"><span><img alt="image" height="187" src="images/Art_P21a.jpg" width="327"/></span></p>
<p class="center"><span>The Family of Miliades (Philaidai)</span></p>
<p class="center1"><span><img alt="image" height="99" src="images/Art_P21b.jpg" width="294"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface002.vue?ebfcca88